export var sidebarServiceIsOpenMenuSelector = function (state) { return Boolean(state.isOpenMenu); };
export var sidebarServiceIsPinnedMenuSelector = function (state) { return Boolean(state.isPinned); };
